<template>
    <div>
        <internal-header v-if="!pdf_view" heading="Member Cards"/>
        <member-cards-report-filters
            v-if="$vuetify.breakpoint.mdAndUp && !pdf_view"
            v-model="filters"
            :constants="constants"
            :valuelists="valuelists"
            />
        <v-expansion-panels v-else-if="!pdf_view" flat>
            <v-expansion-panel>
                <v-expansion-panel-header hide-actions>
                    <template v-slot:default="{ open }">
                        <v-container class="py-0">
                            <v-row no-gutters>
                                <v-col cols="11" class="tw-text-lg">Filters<span v-show="!!filters_used">: {{ filters_used }}</span></v-col>
                                <v-col cols="1">
                                    <v-icon>
                                        <template v-if="open">mdi-minus-circle</template>
                                        <template v-else>mdi-plus-circle</template>
                                    </v-icon>
                                </v-col>
                            </v-row>
                        </v-container>
                    </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <member-cards-report-filters
                        v-model="filters"
                        :constants="constants"
                        :valuelists="valuelists"
                    />
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>

        <div class="tw-flex tw-flex-row tw-w-full tw-justify-between tw-items-center tw-pt-2 tw-pb-1 tw-border-b tw-border-t tw-border-dark-grey" v-if="!pdf_view">
            <div class="flex-grow-1 tw-text-xl tw-font-light" v-show="num_records_filtered">{{ num_records_filtered }} Records</div>
<!--            <div v-if="!pdf_view" v-show="records_are_present" @click="exportAsExcel()" class="flex-grow-0 tw-px-3 tw-text-black tw-underline tw-text-xs tw-font-normal tw-text-link tw-cursor-pointer">Export List</div>-->
            <div v-if="!pdf_view" @click="exportAsPdf()" class="flex-grow-0 tw-px-3 tw-text-black tw-underline tw-text-xs tw-font-normal tw-text-link tw-cursor-pointer">Print List</div>
        </div>

        <smart-table
            ref="report_list"
            endpoint="reports.list.membercards"
            :pdf_endpoint="route('reports.membercards.queue', 'pdf').url()"
            :excel_endpoint="route('reports.membercards.queue', 'excel').url()"
            :items="items"
            hide-default-header
            :hide-default-footer="pdf_view"
            :headers="headers"
            :search="filters.search"
            :multi-sort="true"
            :items-per-page="getDefaultItemsPerPage()"
            :footer-props="{
                'items-per-page-options': getDefaultItemsPerPageOptions()
            }"
            flat
            @fetch-complete="receivedRecordsUpdate"
            export_endpoint="reports.export.membercards"
            export_endpoint_method="post"
            export_filename="membercards-export.xls"
            id="table"
        >
            <template v-slot:header="{ props }">
                <!-- Ensures corrects display when PDF print -->

            </template>

            <template v-slot:item="{ item }">
                <div class="member_card">
                    <span class="issued_to">{{ item.first_name }} {{ item.last_name }}</span>
                    <span class="init_date">{{ item.date_ia_membership }}</span>
                    <span class="if_by_transfer"></span>
                    <span class="by_line">
                        <span class="by_local">667</span>&nbsp;&nbsp;&nbsp;
                        <span class="by_city">Toronto</span>&nbsp;&nbsp;&nbsp;
                        <span class="by_province">Ontario</span>
                    </span>
                    <span class="sig_pres signature first-image" v-if="signatures.President">
                        <img :src="`/storage/signatures/${signatures.President.split('/').pop()}`" alt="President's Signature">
                    </span>
                    <span class="sig_secretary signature" v-if="signatures.Secretary">
                        <img :src="`/storage/signatures/${signatures.Secretary.split('/').pop()}`" alt="Secretary's Signature">
                    </span>
                </div>
            </template>
        </smart-table>

    </div>
</template>

<script>
    import SmartTable from "@/Generic/SmartTable";
    import AppLayout from "@/Layouts/AppLayout.vue";
    import InternalHeader from "@/Generic/InternalHeader.vue";
    import MemberCardsReportFilters from "@/Pages/InternalPages/Reports/MemberCardsReportFilters.vue";

    export default {
        name: "MemberCardsReport",
        layout: (h, page) => {
            return h(AppLayout, [
                page
            ])
        },
        components: {
            InternalHeader,
            SmartTable,
            MemberCardsReportFilters,
        },
        remember: {
            data: [
                'items'
            ]
        },
        props: {
            'constants': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            },
            'valuelists': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            },
            'signatures': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            },
            'items': {          // Will optionally accept a hardcoded list of items instead of getting smart table to fetch them
                type: Array,
                required: false,
                default: function () {
                    return undefined
                }
            },

            'pdf_view': {          // Indicates if this instance is a PDF view
                type: Boolean,
                required: false,
                default: function () {
                    return false
                }
            },
        },
        data() {
            return {
                constant: this.constants,
                filters: {
                    search: null,
                },
                fetch_data_response: null,
                items_local: this.items || null,
            }
        },
        computed: {
            headers() {
                return [
                    { text: '', value: 'empty', sortable: false },
                    {value: 'id',   text: 'ID', align: ' d-none', sortable: true, filterable: true,   },
                    {value: 'first_name',   text: 'First name', align: ' d-none', sortable: true, filterable: true,   },
                    {value: 'last_name',   text: 'Last name', align: ' d-none', sortable: true, filterable: true,   },

                ]
            },
            filters_used() {
                let filters_used = Object.keys(this.filters).filter(filter => (!!this.filters[filter] && this.filters[filter].length))
                if (filters_used?.length === 4) return "All"
                if (!filters_used || filters_used.length === 0) return ""
                return filters_used?.join(", ").toProperCase()
            },
            num_records_total() {
                return this.fetch_data_response?.data?.recordsTotal
            },
            num_records_filtered() {
                return this.fetch_data_response?.data?.recordsFiltered || this.items?.length
            },
            records_are_present() {
                return this.items?.length || this.fetch_data_response?.data?.data?.length
            },
        },
        methods: {
            example() {
                console.log("This is just a test")
            },
            receivedRecordsUpdate(response) {
                this.fetch_data_response = response
            },
            getDefaultItemsPerPage() {
                return this.pdf_view ? -1 : 10
            },
            getDefaultItemsPerPageOptions() {
                return this.pdf_view ? [-1] : [1, 5, 10]
            },
            getFirstAddress(item) {
                let first_mailing = item.mailing_address?.find(address => address.city && address.province?.name)
                let first_billing = item.billing_address?.find(address => address.city && address.province?.name)
                return first_mailing ? first_mailing : (first_billing ? first_billing : null)
            },
            async exportAsExcel() {
                // await this.$refs.report_list.getExport() /* How it's done when you want to export without queue -- Only exports visible records */
                await this.$refs.report_list.getExcel()
            },
            async exportAsPdf() {
                await this.$refs.report_list.getPdf()
            },
        },
        watch: {
            items: {
                handler(newVal, oldVal) {
                    // this.items just got updated
                },
                deep: true,
                immediate: true,
            },
        },
    }
</script>

<style>
.row-pointer tbody tr {
    cursor: pointer;
}

.single-line-text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.no-border {
    border: none !important;
    box-shadow: none !important;
    margin-top: 20px;
    margin-bottom: 20px;
    page-break-inside: avoid;
}


.justify-center {
    justify-content: center !important;
    text-align: center;
}

.signature img {
    width: 150px;
}

.first-image {
    margin-left: 50px;
}

.init_date {
    position: absolute;
    top: 12mm;
    left: 62mm;
}

.issued_to {
    position: absolute;
    top: 8.5mm;
    left: 126mm;
}

.by_line {
    position: absolute;
    top: 13.5mm;
    left: 128mm;
}

.sig_pres {
    position: absolute;
    top: 34mm;
    left: 81mm;
}

.sig_secretary {
    position: absolute;
    top: 31mm;
    left: 147mm;
    max-width: 120px;
}

.member_card
{
    height:     54mm;
    max-height: 54mm;
    position: relative;
    font-size: small;
}

.member_card:nth-child(5n)
{
    height: 42.36mm;
    max-height: 620px;
    page-break-after: always;
}

/* Print-specific styles */

@media print {
    #table {
        margin-top: -80px;
    }

}


@page {
    margin: 0.25in;
}

</style>
